// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { CheckoutUserData } from "@mcmc/App/Store/Reducers";
import { CustomSettingsCollectionModel } from "@mcmc/App/Store/Selectors/SettingsSelectors";
import { CheckoutStep } from "@mcmc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmit.helper";

export function getCurrentStep(state: McMcApplicationState): CheckoutStep | undefined {
    return state.xCheckout.currentStep;
}

export function getCheckoutUserData(
    state: McMcApplicationState,
    cart?: Cart,
    isExpressCheckout?: boolean,
): CheckoutUserData {
    let customUserData;
    if (cart) {
        customUserData = { ...state.xCheckout.userDataById[cart.orderNumber + (isExpressCheckout ? "-express" : "")] };
        // Use the data that exists in the current cartModel only for initialization
        if (customUserData.notes === undefined && cart.notes) {
            customUserData.notes = cart.notes;
        }
        if (customUserData.requestedDeliveryDate === undefined && cart.requestedDeliveryDateDisplay) {
            customUserData.requestedDeliveryDate = cart.requestedDeliveryDateDisplay;
        }
        if (customUserData.paymentMethod === undefined && cart.paymentMethod && cart.paymentMethod.name) {
            customUserData.paymentMethod = cart.paymentMethod.name;
        }
        const shipTo = getShipToState(state, cart.shipToId);
        if (customUserData.poNumber === undefined && (cart.poNumber || shipTo.value?.properties.defaultPo)) {
            customUserData.poNumber = cart.poNumber || shipTo.value?.properties.defaultPo;
        }
    }
    return customUserData || {};
}

export const getShipCompleteCheckboxState = (settings: CustomSettingsCollectionModel) => {
    const {
        customSettings: { showShipCompleteButton, defaultValueForShipCompleteButton },
    } = settings;
    const visible = showShipCompleteButton?.toLowerCase() === "true";
    const defaultValue = defaultValueForShipCompleteButton?.toLowerCase() !== "unchecked";
    return {
        visible,
        defaultValue,
    };
};
